// extracted by mini-css-extract-plugin
module.exports = {"default-layout":"default-layout_default-layout__5VH8b"};